import * as React from 'react';
import { Avatar as NoPhoto, Image } from '@cian/ui-kit';

import { IAgentCard } from '../../../types/agentCard';

import * as styles from './AboutRealtorDesktop.css';

interface IAvatarProps {
  isRound: boolean;
  avatarUrl: IAgentCard['avatarUrl'];
}

export const Avatar = ({ isRound, avatarUrl }: IAvatarProps) => {
  return (
    <div className={styles['avatar-container']}>
      <div className={styles['avatar']}>
        {avatarUrl ? (
          <Image src={avatarUrl} width={120} borderRadius={isRound ? '50%' : '4px'} objectFit="contain" />
        ) : (
          <NoPhoto size={120} type={'agency'} />
        )}
      </div>
    </div>
  );
};
